import { diffLines } from 'diff';

export type PairedJsonDiffRow = {
  left: string;
  right: string;
  highlightLeft: boolean;
  highlightRight: boolean;
};

function splitToDisplayLines(value: string): string[] {
  if (value === '') return [];
  const parts = value.split('\n');
  if (parts.length > 0 && parts[parts.length - 1] === '' && value.endsWith('\n')) {
    parts.pop();
  }
  return parts;
}

export function buildPairedJsonDiffRows(before: string, after: string): PairedJsonDiffRow[] {
  const rows: PairedJsonDiffRow[] = [];
  const hunks = diffLines(before ?? '', after ?? '', {
    ignoreWhitespace: false,
    newlineIsToken: true,
  });

  for (const hunk of hunks) {
    const lines = splitToDisplayLines(hunk.value);

    if (hunk.removed) {
      for (const line of lines) {
        rows.push({
          left: line,
          right: '',
          highlightLeft: true,
          highlightRight: false,
        });
      }
    } else if (hunk.added) {
      for (const line of lines) {
        rows.push({
          left: '',
          right: line,
          highlightLeft: false,
          highlightRight: true,
        });
      }
    } else {
      for (const line of lines) {
        rows.push({
          left: line,
          right: line,
          highlightLeft: false,
          highlightRight: false,
        });
      }
    }
  }

  return rows;
}
